


// Menu Toggle Js
$(document).ready(function(){
  $(".about-toggle").on("click", function(e){
    e.preventDefault();
    $(this).toggleClass("active");
    $(".mega-menu-wrapper").toggleClass("active");
    e.stopPropagation(); // stop click from bubbling to body
  });

  $(".mega-menu-wrapper").on("click", function(e){
    e.stopPropagation(); // prevent close when clicking inside menu
  });

  $(document).on("click", function(){
    // click anywhere on body → close
    $(".about-toggle, .mega-menu-wrapper").removeClass("active");
  });
});


// Blog__posts Slider
 $(".blog .blog__posts").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    adaptiveHeight: true,
    centerPadding: "70px", // Slick applies padding equally on both sides
    cssEase: "ease", // smoother sliding
    prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="19" viewBox="0 0 50 19" fill="currentcolor"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0102 18.404C9.98583 18.4628 9.9501 18.5162 9.90507 18.5612C9.86008 18.6063 9.80666 18.642 9.74786 18.6664C9.68906 18.6907 9.62603 18.7033 9.56237 18.7033C9.49872 18.7033 9.43569 18.6907 9.37689 18.6664C9.31808 18.642 9.26466 18.6063 9.21968 18.5612L0.500931 9.84247C0.455898 9.79749 0.42017 9.74407 0.395794 9.68527C0.371418 9.62646 0.358871 9.56343 0.358871 9.49978C0.358871 9.43612 0.371418 9.37309 0.395794 9.31429C0.42017 9.25549 0.455898 9.20207 0.500931 9.15708L9.21968 0.438335C9.26468 0.393332 9.31811 0.357633 9.37691 0.333277C9.43571 0.308922 9.49873 0.296387 9.56237 0.296387C9.62602 0.296387 9.68904 0.308922 9.74784 0.333277C9.80664 0.357633 9.86007 0.393332 9.90507 0.438335C9.95007 0.483338 9.98577 0.536765 10.0101 0.595565C10.0345 0.654365 10.047 0.717386 10.047 0.78103C10.047 0.844675 10.0345 0.907696 10.0101 0.966496C9.98577 1.0253 9.95007 1.07872 9.90507 1.12373L2.01339 9.0154L20 9.0154V9H50V10H20V9.98415L2.01339 9.98415L9.90507 17.8758C9.9501 17.9208 9.98583 17.9742 10.0102 18.033C10.0346 18.0918 10.0471 18.1549 10.0471 18.2185C10.0471 18.2822 10.0346 18.3452 10.0102 18.404Z"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="19" viewBox="0 0 50 19" fill="currentcolor"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.9898 18.404C40.0142 18.4628 40.0499 18.5162 40.0949 18.5612C40.1399 18.6063 40.1933 18.642 40.2521 18.6664C40.3109 18.6907 40.374 18.7033 40.4376 18.7033C40.5013 18.7033 40.5643 18.6907 40.6231 18.6664C40.6819 18.642 40.7353 18.6063 40.7803 18.5612L49.4991 9.84247C49.5441 9.79749 49.5798 9.74407 49.6042 9.68527C49.6286 9.62646 49.6411 9.56343 49.6411 9.49978C49.6411 9.43612 49.6286 9.37309 49.6042 9.31429C49.5798 9.25549 49.5441 9.20207 49.4991 9.15708L40.7803 0.438335C40.7353 0.393332 40.6819 0.357633 40.6231 0.333277C40.5643 0.308922 40.5013 0.296387 40.4376 0.296387C40.374 0.296387 40.311 0.308922 40.2522 0.333277C40.1934 0.357633 40.1399 0.393332 40.0949 0.438335C40.0499 0.483338 40.0142 0.536765 39.9899 0.595565C39.9655 0.654365 39.953 0.717386 39.953 0.78103C39.953 0.844675 39.9655 0.907696 39.9899 0.966496C40.0142 1.0253 40.0499 1.07872 40.0949 1.12373L47.9866 9.0154L30 9.0154V9H0V10H30V9.98415L47.9866 9.98415L40.0949 17.8758C40.0499 17.9208 40.0142 17.9742 39.9898 18.033C39.9654 18.0918 39.9529 18.1549 39.9529 18.2185C39.9529 18.2822 39.9654 18.3452 39.9898 18.404Z"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1145,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px",
        }
      }
    ]
  });

  // Blog__posts Slider
 $(".article-gallery-slider").slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1145,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });


document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("/cart")) {
    const leftCart = document.querySelector(".left-side-cart");
    const cartFooter = document.querySelector(".cart__footer-wrapper");
    const anotherChild = document.querySelector(".all-cart-wrapper");

    if (leftCart && cartFooter) {
      // Create wrapper
      const mergedWrapper = document.createElement("div");
      mergedWrapper.classList.add("cart-merged-wrapper");

      // Create inner wrapper (child container)
      const childWrapper = document.createElement("div");
      childWrapper.classList.add("cart-merged-child");

      // Insert mergedWrapper before leftCart
      leftCart.parentNode.insertBefore(mergedWrapper, leftCart);

      // Append child wrapper into mergedWrapper
      mergedWrapper.appendChild(childWrapper);

      // Move leftCart + cartFooter into childWrapper
      childWrapper.appendChild(leftCart);
      childWrapper.appendChild(cartFooter);

      // If .all-cart-wrapper exists, move its children into mergedWrapper (after childWrapper)
      if (anotherChild) {
        while (anotherChild.firstChild) {
          mergedWrapper.appendChild(anotherChild.firstChild);
        }
      }
    }
  }
});


let exchangeRates = {};

// Fetch live rates (base DKK → EUR, etc.)
async function fetchRates() {
  try {
    const res = await fetch("https://api.exchangerate.host/latest?base=DKK&symbols=EUR,DKK");
    const data = await res.json();
    exchangeRates = data.rates;
  } catch (err) {
    console.error("Currency API error:", err);
    // fallback if API fails
    exchangeRates = { DKK: 1, EUR: 0.13 };
  }
}

// Format price in selected currency
const formatCurrency = (amount, currency) => {
  return new Intl.NumberFormat(currency === "EUR" ? "de-DE" : "da-DK", {
    style: "currency",
    currency: currency
  }).format(amount);
};

// Convert all prices
function convertPrices(toCurrency) {
  document.querySelectorAll(".price").forEach(el => {
    const baseValue = parseFloat(el.getAttribute("data-base-price"));
    if (!isNaN(baseValue)) {
      const rate = exchangeRates[toCurrency] || 1;
      const converted = baseValue * rate;
      el.innerText = formatCurrency(converted, toCurrency);
    }
  });
  localStorage.setItem("selectedCurrency", toCurrency);
}

// Handle switcher click
document.querySelectorAll(".currency-option").forEach(el => {
  el.addEventListener("click", function() {
    document.querySelectorAll(".currency-option").forEach(opt => opt.classList.remove("active"));
    this.classList.add("active");
    convertPrices(this.dataset.currency);
  });
});

// Init on page load
document.addEventListener("DOMContentLoaded", async () => {
  const savedCurrency = localStorage.getItem("selectedCurrency") || "DKK";
  document.querySelector(`.currency-option[data-currency="${savedCurrency}"]`).classList.add("active");

  // Save original prices
  document.querySelectorAll(".price").forEach(el => {
    if (!el.hasAttribute("data-base-price")) {
      const raw = el.innerText.replace(/[^\d,.-]/g, "").replace(",", ".");
      el.setAttribute("data-base-price", raw);
    }
  });

  await fetchRates();
  convertPrices(savedCurrency);
});



const intervalId = setInterval(() => {
  const checkboxes = document.querySelectorAll('.card-checkbox input[type="checkbox"]');

  if (checkboxes.length > 0) {
    // Attach event listeners
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const cardCheckbox = this.closest('.card-checkbox');
        const quickAdd = cardCheckbox.parentElement.querySelector('.quick-add');

        if (this.checked) {
          quickAdd.classList.remove('hidden');
        } else {
          quickAdd.classList.add('hidden');
        }
      });
    });

    // Stop the interval since elements are found and listeners attached
    clearInterval(intervalId);
  }
}, 100); // check every 100ms


// Use a variable related to the element



jQuery(document).ready(function(){
  jQuery('.slider_images').slick({
    speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
    slidesToShow: 4,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
});

jQuery(document).ready(function () {
  jQuery('.announcement-slider').slick({
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    prevArrow: `
      <button type="button" class="slick-prev">
        <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-arrow-left icon--direction-aware" viewBox="0 0 16 18" style="transform: rotate(180deg);">
          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      </button>
    `,
    nextArrow: `
      <button type="button" class="slick-next">
        <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-arrow-right icon--direction-aware" viewBox="0 0 16 18">
          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      </button>
    `
  });
});

	